/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Model_CountryGet } from '../models/Model_CountryGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountryService {
    /**
     * @returns Model_CountryGet Success
     * @throws ApiError
     */
    public static getApiV1Countries(): CancelablePromise<Array<Model_CountryGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/countries',
        });
    }
}
